import { render, staticRenderFns } from "./ProductBaseAttr.vue?vue&type=template&id=11a4badf&scoped=true&"
import script from "./ProductBaseAttr.vue?vue&type=script&lang=js&"
export * from "./ProductBaseAttr.vue?vue&type=script&lang=js&"
import style0 from "./ProductBaseAttr.vue?vue&type=style&index=0&id=11a4badf&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a4badf",
  null
  
)

export default component.exports